export default "<div class=\"accordian\">\n  <ng-content></ng-content>\n</div>\n"